import React from 'react'
import Template from '../components/Template'

export default function Home() {
    return (
        <div>
            <Template>
                <div className="card ">
                    <div className="card-header">
                        <div className="card-title">
                            <h3>Welcome to POS</h3>
                        </div>
                    </div>
                </div>
            </Template>
        </div>
    )
}
